let AOS = require('aos');
setTimeout(() => {
    AOS.init()
}, 200);

